import script from "./chart-pie.vue?vue&type=script&setup=true&lang=ts"
export * from "./chart-pie.vue?vue&type=script&setup=true&lang=ts"

import "./chart-pie.vue?vue&type=style&index=0&id=01e79d88&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01e79d88"]])

export default __exports__